import React from 'react'
import { Styles } from '../../../../@types/types'

const styles: Styles = {
  fixedFieldHeight: { height: 40 },
}

export interface CombinedFieldItemProps {
  id: string
  label: string
  children: React.ReactNode
  wrapperClassName?: string
}

const CombinedFieldItem: React.FC<CombinedFieldItemProps> = ({
  id,
  label,
  children,
  wrapperClassName = 'margin-top-l',
}) => (
  <>
    <div className={`grid-item one-half ${wrapperClassName}`}>
      <div className='vertical-center-container' style={styles.fixedFieldHeight}>
        <label
          className='vertical-center font-body-medium-bold margin-left-xxl desk-margin-left-m lap-margin-left-m path-symbol-before'
          htmlFor={id}
          id={`${id}-input-label`}
        >
          {label}
        </label>
      </div>
    </div>
    <div className={`grid-item one-half padding-left-m ${wrapperClassName}`}>{children}</div>
  </>
)

export default CombinedFieldItem
